

import {useStore} from '@/main'
import {
  ref,
} from "vue";
 import Tabbar from "@/components/tabbar/index.vue";
export default {
  components: { 
   Tabbar,
  },
  setup(){
    const Store:any =  useStore();
    const token = Store.getToken();
    const iframe_url = `${window.common.old_url()}/message_list?token=${token}&uid=${common.getStorage('user_info') ? common.getStorage('user_info').id : ''}`;
    const tabbar_index = ref(2);

    return {
        tabbar_index,
        iframe_url
    }
  }
}
